<template>
    <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
      <div class="space-y-1 text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
          <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <div class="flex justify-center text-sm text-gray-600">
          <label :for="'file-upload-' + ukey" class="text-center relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
            <span>Upload a File</span>
            <input :id="'file-upload-' + ukey" :name="'file-upload-' + ukey" :ref="'file-' + ukey" type="file" class="sr-only" @change="uploadFile" :key="ukey">
          </label>
        </div>
        <p class="text-xs text-gray-500">
          {{ supportedtypes }} up to 10MB
        </p>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        endpoint: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        ukey: {
            type: String
        },
        supportedtypes: {
            type: String,
            default: "PDF, DOC, DOCX, PNG, JPG"
        }
    },
    data: function () {
        return {
            file: null
        }
    },
    methods: {
        uploadFile() {
            this.file = this.$refs['file-' + this.ukey].files[0];
            this.submitFile();
        },
        submitFile() {
            const formData = new FormData();

            formData.append('file', this.file);
            formData.append('type', this.type);

            const headers = { 'Content-Type': 'multipart/form-data' };

            window.axios.post(this.endpoint, formData, { headers })
            .then((res) => {
                location.reload();
            });
          }
    }
}
</script>
